module.exports = __webpack_public_path__ + "media/images/farey/index/estimation_gratuite_de_votre_cabinet_medical-df6155f16608dd4c849331046b6af437.png";